import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/erinwang/Documents/GitHub/portfolio-v3/src/components/portfolio-page.js";
import { Link } from 'gatsby';
import { SingleImage, MultiImage, MultiImageContainer } from '../../src/components/portfolio-page';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Welcome to The Morning Mishap!`}</h2>
    <p>{`A (currently) fictional coffee shop for a friend who dreams of opening his own cafe business one day.
He asked be to create a fun brand – including the name! – for him when he does decide to go forth on that dream.`}</p>
    <h2>{`figuring out the name`}</h2>
    <p>{`Names were inspired by puns, inside jokes (but also made sense towards a general customer), and the classy but basic ones.`}</p>
    <MultiImageContainer mdxType="MultiImageContainer">
      <MultiImage src='../../images/mishap/name-generation.jpeg' mdxType="MultiImage" />
    </MultiImageContainer>
    <p>{`I mean, ideate and iterate until something sticks – right?`}</p>
    <p>{`Eventually, my three friends and I got together and discussed as a group which names we liked. Noveltea was a good pun – but we looked it up and realized that there are many tea places with ‘-tea’ in the end. Beanie Meanie was funny, but it didn’t reflect his personality.
The Morning Mishap was perfect. Luis is a man of mistakes; Coffee can cause many blunders. With a good attitude though, these accidents can become stories – and what’s the point of living without experiencing a few mishaps?`}</p>
    <h2>{`what’s a brand without a logo?`}</h2>
    <p>{`Cracks of cups and splashes of the joe slowly became the motif of this shop.`}</p>
    <MultiImageContainer mdxType="MultiImageContainer">
      <MultiImage src='../../images/mishap/logos.jpeg' mdxType="MultiImage" />
      <MultiImage src='../../images/mishap/mishap.png' mdxType="MultiImage" />
    </MultiImageContainer>
    <p>{`“The” was the hardest word to put in this logo. It’s weird to put it in the same importance as the other two words, but it also seems off-putting and distracting when making it small.`}</p>
    <h2>{`fun brand items`}</h2>
    <SingleImage src='../../images/mishap/coffee-mockups.png' mdxType="SingleImage" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      